import styled from 'styled-components';
import { SELECTOR_POSITION } from './constants';

export const SelectorContainer = styled.div`
	position: absolute;
	bottom: ${props => props.$bottom || SELECTOR_POSITION.default}px;
	right: ${SELECTOR_POSITION.right}px;
	z-index: 19;
`;

export const SelectorButton = styled.button`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	border: 1px solid rgba(${props => props.theme.colors.borderLightRgb}, 0.1);
	/*	background: rgba(${props => props.theme.colors.panelBackgroundRgb}, 0.7); */
	background: ${props => props.theme.colors.background};
	color: ${props => props.theme.colors.textColor};
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.15s ease;
	backdrop-filter: blur(12px);

	&:hover {
		background: rgba(${props => props.theme.colors.panelBackgroundRgb}, 0.85);
		transform: scale(1.05);
	}
`;

export const SelectorPanel = styled.div`
	position: absolute;
	bottom: 48px;
	right: 0;
	/*	background: rgba(${props => props.theme.colors.panelBackgroundRgb}, 0.7); */
	background: ${props => props.theme.colors.background};

	border: 1px solid rgba(${props => props.theme.colors.borderLightRgb}, 0.1);
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
	padding: 12px;
	min-width: 180px;
	animation: slideUp 0.15s ease;
	/* backdrop-filter: blur(16px); */

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(8px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const PanelTitle = styled.div`
	font-size: 0.75rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: ${props => props.theme.colors.textAccent};
	margin-bottom: 12px;
	padding-bottom: 8px;
	border-bottom: 1px solid ${props => props.theme.colors.border};
`;

export const OptionsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const OptionButton = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 10px;
	border: none;
	border-radius: 4px;
	background: ${props => (props.$selected ? props.theme.colors.green + '20' : 'transparent')};
	color: ${props => (props.$selected ? props.theme.colors.green : props.theme.colors.textColor)};
	cursor: pointer;
	text-align: left;
	font-size: 0.9rem;
	transition: all 0.1s ease;

	&:hover {
		background: ${props =>
			props.$selected
				? props.theme.colors.green + '30'
				: props.theme.colors.backgroundAccent + '30'};
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;

		&:hover {
			background: transparent;
		}
	}
`;

export const OptionIcon = styled.span`
	display: flex;
	align-items: center;
	width: 20px;
`;

export const Divider = styled.div`
	height: 1px;
	background: ${props => props.theme.colors.border};
	margin: 8px 0;
`;

export const OpacityRow = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 10px;
`;

export const OpacityLabel = styled.span`
	font-size: 0.8rem;
	color: ${props => props.theme.colors.textAccent};
	min-width: 50px;
`;

export const OpacitySlider = styled.input`
	flex: 1;
	max-width: 100px;
	cursor: pointer;
`;

export const OpacityValue = styled.span`
	font-size: 0.8rem;
	color: ${props => props.theme.colors.textColor};
	min-width: 30px;
	text-align: right;
`;
